import { QueryKey } from 'constants/reactQuery';

export const systemQueryKey = {
  featureFlagConfig: () => [QueryKey.System, 'featureFlagConfig'] as const,
  maintenance: () => [QueryKey.System, 'maintenance'] as const,
};
